import type { FC } from "react";

import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Button, ButtonLabel } from "@similarweb/ui-components";

import { ButtonGroup } from "../../ButtonsGroup/src/ButtonsGroup";
import I18n from "../../WithTranslation/src/I18n";

import { TableSelectionContainer } from "./StyledComponents";

interface ITableSelectionKeywordsWarningProps {
    message: string;
    onCancel: () => void;
}

const Message = styled.div`
    display: flex;
    align-items: center;
    ${setFontVariant("body1", colorsPalettes.carbon[400])}
    margin-bottom: 40px;
`;
const ErrorIcon = styled(SWReactIcons)`
    flex-grow: 0;
    flex-shrink: 0;
    margin-right: 5px;
    svg {
        path {
            fill: ${colorsPalettes.red["s100"]};
        }
    }
`;

const MessageText = styled.div`
    flex-grow: 1;
`;

export const TableSelectionKeywordsWarning: FC<ITableSelectionKeywordsWarningProps> = ({ message, onCancel }) => {
    return (
        <TableSelectionContainer>
            <Message>
                <MessageText>{message}</MessageText>
            </Message>
            <ButtonGroup>
                <Button
                    type="flat"
                    onClick={onCancel}
                >
                    <ButtonLabel>
                        <I18n>table.selection.newgroup.cancel</I18n>
                    </ButtonLabel>
                </Button>
            </ButtonGroup>
        </TableSelectionContainer>
    );
};

TableSelectionKeywordsWarning.displayName = "TableSelectionKeywordsWarning";
